import { Action, createReducer, on } from '@ngrx/store';
import * as ClosuresActions from '../actions/closures.actions';
import { Closures, ClosuresDTO, ClosuresFilters } from '../../commons/models/closures';

export interface ClosureState {
    list: ClosuresDTO[],
    total: number,
    includes: string[],
    currentPage: number,
    perPage: number,
    order: string,
    direction: string,
    filters: ClosuresFilters,
    dialogId: string,
    selectionDialogId: string,
    selectedClosures: Closures[],
    //selectedTenantId: number;
};

const initialState: ClosureState = {
    list: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 25,
    order: null,
    direction: null,
    filters: null,
    dialogId: null,
    selectionDialogId: null,
    //selectedTenantId: null,
    selectedClosures: []
};

const closuresReducer = createReducer(
    initialState,
    on(ClosuresActions.loadClosuresCompleted, (state, {closures, currentPage, total, perPage, order, direction, filters, includes}) => {
        return { ...state, list: closures, currentPage, total, perPage, order, direction, filters, includes };
    }),
    on(ClosuresActions.closureDialogOpened, (state, {dialogId}) => {
        return {...state, dialogId};
    }),
    on(ClosuresActions.selectClosureSuccess, (state, { closure }) => {
        return {...state, selectedClosures: []}
    }),
);

export function reducer(state: ClosureState | undefined, action: Action) {
    return closuresReducer(state, action);
}